import { addInformationsOfFacesInLignes } from '@/services/logistique/tourneeModele/addInformationPatrimonialTourneeLigne';
import { getAll } from '@/api/gabed/face/index';
import { NO_PAGINATION } from '@/configuration/clientTableConf';
import getAllTourneeLigne from '@/api/logistique/tourneeLigne/index';
import messageInfo from '@/services/general/messageInformation';
import { getAffectationRegroupement } from '@/api/produit/produitFace';
import formatIsoDate from '@/services/general/formatIsoDate';
import * as tourneeConf from '@/configuration/logistique/tournee/tourneeConf';
import sortTourneeModele from '@/services/logistique/tourneeModele/sortTourneeModele';

async function getFacesIds(facesPatrimoniales, societeId, facesIdDejaPresente, idTournee) {
  const facesIds = facesPatrimoniales.filter((f) => {
    return !facesIdDejaPresente.some((id) => {
      return f.id === id;
    });
  }).map((f) => { return f.id; });

  const tourneeLigneWithFaceId = (
    await getAllTourneeLigne({
      query: { faceIds: facesIds, societeId: societeId },
      limit: NO_PAGINATION,
    })
  ).data.result.items;
  return facesIds.filter((faceId) => {
    return !tourneeLigneWithFaceId.some((ligne) => {
      return ligne.faceId === faceId && ligne.tournee.id !== idTournee;
    });
  });
}

async function getTourneesLignes(
  facesPatrimoniales, maxOrdre, societeId, facesIdDejaPresente, idTournee,
) {
  const tourneeLignes = [];
  let ordre = maxOrdre;
  const facesIds = await getFacesIds(facesPatrimoniales, societeId, facesIdDejaPresente, idTournee);
  if (facesIds.length === 0) return [];
  facesIds.forEach((id) => {
    tourneeLignes.push({ faceId: id, ordre: ordre });
    ordre += 10;
  });
  if (facesPatrimoniales.length === 0) return [];
  const reseauInformation = (await getAffectationRegroupement({
    dateVisu: formatIsoDate(new Date()),
    produitIds: facesPatrimoniales
      .filter((face) => { return face.produitId; })
      .map((face) => { return face.produitId; }),
  })).data.result;
  addInformationsOfFacesInLignes(facesPatrimoniales, tourneeLignes, reseauInformation);
  sortTourneeModele(tourneeLignes);
  return tourneeLignes;
}

async function getMessagesInfo(facesPatrimoniales, tourneeLigne, societeId, i18n, messages) {
  const facesDejaPrisId = facesPatrimoniales.filter((face) => {
    return !tourneeLigne.some((ligne) => {
      return face.id === ligne.faceId;
    });
  }).map((f) => { return f.id; });
  const tourneeLigneFaceDejaPris = (
    await getAllTourneeLigne({
      query: { faceIds: facesDejaPrisId, societeId: societeId },
      limit: NO_PAGINATION,
    })
  ).data.result.items;
  tourneeLigneFaceDejaPris.forEach(tourneeLigne => {
    const face = facesPatrimoniales.find((face) => {
      return face.id === tourneeLigne.faceId;
    });
    messages.push({
      codeFace: face.code,
      motif: i18n.t('addEditTourneeModele.facesNotAddListeAffichage.faceSurListeAffichage', { liste: tourneeLigne.tournee.libelle }),
    });
  });
}

export async function getTourneeLigneFromPatrimoine(
  element, ordre, societeId, facesIdDejaPresente, i18n, idTournee, messages,
) {
  const params = {
    query: { societeId: societeId, nonCommercialisable: false },
    limit: NO_PAGINATION,
  };
  switch (element.typeProduit) {
    case tourneeConf.TYPE_MATERIEL:
      params.query.materielIds = [element.id];
      break;
    case tourneeConf.TYPE_DISPOSITIF:
      params.query.dispositifIds = [element.id];
      break;
    case tourneeConf.TYPE_EMPLACEMENT:
      params.query.emplacementIds = [element.id];
      break;
    default: break;
  }
  const facesPatrimoniales = (await getAll(params)).data.result.items;
  const tourneeLigne = await getTourneesLignes(
    facesPatrimoniales, ordre, societeId, facesIdDejaPresente, idTournee,
  );
  if (facesPatrimoniales.length !== tourneeLigne.length) {
    await getMessagesInfo(facesPatrimoniales, tourneeLigne, societeId, i18n, messages);
  } else if (facesPatrimoniales.length > 1) {
    messageInfo(i18n.t('addEditTourneeModele.info.facesAddSuccessMulti'));
  } else {
    messageInfo(i18n.t('addEditTourneeModele.info.facesAddSuccess'));
  }

  return tourneeLigne;
}

export async function getTourneeLigneFromPatrimoinesListe(
  elements, ordre, societeId, facesIdDejaPresente, i18n, idTournee, messages,
) {
  const params = {
    query: {
      societeId: societeId,
      nonCommercialisable: null,
      materielIds: [],
      dispositifIds: [],
      emplacementIds: [],
    },
    limit: NO_PAGINATION,
  };
  elements.forEach((element) => {
    switch (element.typeProduit) {
      case tourneeConf.TYPE_MATERIEL:
        params.query.materielIds.push(element.id);
        break;
      case tourneeConf.TYPE_DISPOSITIF:
        params.query.dispositifIds.push(element.id);
        break;
      case tourneeConf.TYPE_EMPLACEMENT:
        params.query.emplacementIds.push(element.id);
        break;
      default: break;
    }
  });
  const facesPatrimoniales = (await getAll(params)).data.result.items;
  const tourneeLigne = await getTourneesLignes(
    facesPatrimoniales, ordre, societeId, facesIdDejaPresente, idTournee,
  );
  if (facesPatrimoniales.length !== tourneeLigne.length) {
    await getMessagesInfo(facesPatrimoniales, tourneeLigne, societeId, i18n, messages);
  } else if (facesPatrimoniales.length > 1) {
    messageInfo(i18n.t('addEditTourneeModele.info.patrimoineAddSuccessMulti'));
  } else if (facesPatrimoniales.length === 1) {
    messageInfo(i18n.t('addEditTourneeModele.info.patrimoineAddSuccess'));
  }

  return tourneeLigne;
}
